import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SecureLoadingContent from 'components/components/common/SecureLoadingContent';
import withRouter from 'components/components/common/withRouter';
import { connect } from 'react-redux';
import resizer from 'components/common/Resizer';
import AppLink from 'components/common/AppLink';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';

const MenuItem = ({ link, fa_cat = 'fas', fa_name, name, locale }) => (
  <li className="list-border__item">
    <AppLink to={link}>
      <FontAwesomeIcon
        icon={[`${fa_cat}`, `${fa_name}`]}
      />
      {TransHelper.translate(locale, name)}
      <FontAwesomeIcon
        icon={['fas', 'angle-right']}
      />
    </AppLink>
  </li>
);

class Help extends Component {

  render() {
    const isMobileW = this.props.windowWidth <= 959;
    const { locale } = this.props;

    return (
      <SecureLoadingContent softLoading>
        <div className="content" style={{ padding: '0' }}>

          <div className={classNames(
            'grid-layout', {
              'grid-layout--rwd': isMobileW
            }
          )}>
            <div className={classNames(
              'grid-layout__item',
              'grid-layout__item--desc',
              'grid-layout__item--middle',
            )}>
              <div className="content__desc">
                <div className="user-profile user-profile--width-auto">
                  <header className="head mb-30">
                    <h3><T>content.help.header</T></h3>
                  </header>

                  <div className="help-info">
                    <p><T>content.help.question</T></p>
                    <p><T>content.help.checkLink</T></p>
                    <div className="help-info__contact">
                      <p><a href="mailto:support@flyo.no">support@flyo.no</a></p>
                    </div>
                    <p style={{ fontSize: '15px' }}>
                      <em><T>content.help.officeWorks</T></em>
                    </p>
                  </div>

                </div>
              </div>
            </div>

            <div className={classNames(
              'grid-layout__item',
              'grid-layout__item--desc',
              'grid-layout__item--middle',
              'grid-layout__item--arrow',
              'grid-layout__item--light',
            )}>

              <div className="content__desc">
                <ul className="list-border" style={{ margin: 0 }}>
                  {/* <MenuItem
                    fa_name="cogs"
                    name="content.layout.menuMain.howItWorks"
                    link="routes.url.howItWorks"
                    locale={locale}
                  /> */}
                  <MenuItem
                    fa_name="comments"
                    name="content.layout.menuMain.faq"
                    link="routes.url.faq"
                    locale={locale}
                  />
                  <MenuItem
                    fa_name="tag"
                    name="content.layout.menuMain.pricing"
                    link="routes.url.prices"
                    locale={locale}
                  />
                  <MenuItem
                    fa_name="envelope"
                    name="content.layout.menuMain.contact"
                    link="routes.url.contact"
                    locale={locale}
                  />
                </ul>

                <p className="foot-copyright">
                  <T>content.help.rightsReserved</T>
                </p>
              </div>
            </div>
          </div>
        </div>
      </SecureLoadingContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customer: state.auth.customer,
    locale: state.app.locale
  }
}

export default withRouter(
  resizer(
    connect(
      mapStateToProps,
    )(Help)
  )
);
